<template>
  <div class="create-order">
    <div class="flex items-center bg-neutral-700 py-10 px-40 stepper relative mdmax:px-4 mdmax:text-center mdmax:gap-2 mdmax:-mx-4 mdmax:py-6 mdmax:items-stretch">
      <div class="flex-1 py-2 px-6 rounded bg-neutral-600 mdmax:pl-3 mdmax:pr-3" :class="{ arrow: !isMobile }">
        <p class="text-sm font-medium text-white">{{ $t('order.createOrder.stepOne.title') }}</p>
        <p class="text-xs text-white">{{ $t('order.createOrder.stepOne.desc') }}</p>
      </div>
      <div class="flex-1 py-2 pl-10 pr-6 bg-primary-100 rounded mdmax:pl-3 mdmax:pr-3" :class="{ arrow: !isMobile }">
        <p class="text-sm font-medium ">Logistik & Pembayaran</p>
        <p class="text-xs text-neutral-500">Pilih logistik dan bayar</p>
      </div>
    </div>
    <div class="flex bg-white shadow-border-b pb-px mdmax:flex-col w-full">
      <div class="w-2/5 shadow-border-r pr-px mdmax:w-full">
        <div class="py-3 px-8 flex gap-9 items-center bg-neutral-200 mdmax:px-4">
          <Box2 color="primary-500" />
          <div class="flex flex-col">
            <p class="text-xs">{{ $t('order.createOrder.stepTwo.show') }} {{ Object.keys(deliveryServiceByGroup).length }} {{ $t('order.createOrder.stepTwo.deliveryService') }}</p>
            <p class="font-bold">{{ shippingInfo?.hub?.origin?.district }} - {{ shippingInfo?.hub?.destination?.district }}</p>
          </div>
        </div>
        <div class="group px-5">
          <template v-if="recommendedDeliveryServices.length > 0">
            <div class="mb-8 p-4 bg-secondary-50 border border-secondary-300 rounded-lg relative overflow-hidden shadow-sm">
              <div class="absolute top-0 right-0 bg-secondary-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg tracking-wider uppercase">
                Rekomendasi
              </div>
              <div class="flex flex-col gap-3">
                <div
                  class="flex justify-between items-center py-3 px-4 rounded-lg cursor-pointer transition-all duration-200 border bg-white"
                  :class="{
                    'border-secondary-500 shadow-md ring-1 ring-secondary-500': selectedPackageDelivery?.package?.id === service.package.id,
                    'border-neutral-200 hover:border-secondary-300 hover:shadow-sm': selectedPackageDelivery?.package?.id !== service.package.id,
                    'bg-neutral-100 opacity-60 cursor-not-allowed border-neutral-200':
                      parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight) ||
                      parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight) ||
                      parseInt(service.package.final_cost) <= 0
                  }"
                  :disabled="
                    parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight) ||
                      parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight) ||
                      parseInt(service.package.final_cost) <= 0
                  "
                  v-for="(service, idx) in recommendedDeliveryServices"
                  @click="
                    parseInt(shippingInfo?.receiver?.weight) >= parseInt(service.package.minimum_weight) &&
                    parseInt(shippingInfo?.receiver?.weight) <= parseInt(service.package.maximum_weight) &&
                    parseInt(service.package.final_cost) > 0
                      ? selectPackage(service.package, service)
                      : null
                  "
                  :key="'rec-service' + idx"
                >
                  <div class="flex gap-4 items-center">
                    <div class="flex justify-center items-center w-16 h-12 bg-neutral-50 rounded p-1 border border-neutral-100">
                      <img :src="service.logo" :alt="service.name" class="max-h-10 object-contain" v-if="service.logo" />
                      <LogisticPlaceholder :logisticName="service.name" v-else />
                    </div>
                    <div>
                      <p class="text-sm font-semibold text-neutral-800">
                        {{ service.package.name }}
                      </p>
                      <template v-if="parseInt(service.package.final_cost) <= 0">
                        <p class="text-xs text-red-500 mt-0.5">{{ $t('order.createOrder.stepTwo.unavailableService') }}</p>
                      </template>
                      <template v-else-if="parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight)">
                        <p class="text-xs text-neutral-500 mt-0.5">
                          {{ $t('order.createOrder.stepTwo.minimumWeight') }} {{ service.package.name }} {{ service.package.minimum_weight }} Kg
                        </p>
                      </template>
                      <template v-else-if="parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight)">
                        <p class="text-xs text-neutral-500 mt-0.5">
                          {{ $t('order.createOrder.stepTwo.maximumWeight') }} {{ service.package.name }} {{ service.package.maximum_weight }} Kg
                        </p>
                      </template>
                      <template v-else>
                        <p class="text-xs text-secondary-600 mt-0.5 font-medium flex items-center gap-1">
                          <Time color="secondary-600" width="12" height="12" /> {{ service.package.est_delivery_time_range_min }} - {{ service.package.est_delivery_time_range_max }}
                        </p>
                      </template>
                    </div>
                  </div>
                  <div class="flex flex-col justify-end items-end text-right" v-if="parseInt(service.package.final_cost) > 0">
                    <p class="text-xs text-neutral-400 line-through mb-0.5" v-if="service.package.final_cost !== service.package.shipment_cost">
                      {{ service.package.shipment_cost | currencyFormat }}
                    </p>
                    <p class="text-base font-bold text-primary-600">
                      {{ service.package.final_cost | currencyFormat }}
                      <template v-if="shippingInfo.is_require_pod"><span class="text-xs text-neutral-500 font-normal block">&nbsp;+&nbsp;{{ service.package?.return_delivery_service_packages[0]?.final_cost | currencyFormat }} (POD)</span></template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <p class="mt-4 font-bold mb-4">{{ $t('order.createOrder.stepTwo.deliveryServiceTitle') }}</p>
          <template v-if="deliveryServices.length > 0">
            <div class="overflow-hidden mb-6 pr-1" v-for="(value, key, index) in deliveryServiceByGroup" :key="index">
              <input type="checkbox" :id="key" :checked="value.isVisible" />
              <label :for="key" class="flex justify-between shadow-border-b pb-2 cursor-pointer" @click="expand(key, value.isVisible)">
                <p class="text-sm ">{{ key }}</p>
                <span :class="{ 'transform rotate-180': value.isVisible }">
                  <Chevron direction="down" />
                </span>
              </label>
              <div class="sub" :class="{ open: value.isVisible }">
                <div
                  class="flex justify-between items-center shadow-border py-2 px-4 rounded-md mb-3 last:mb-0 cursor-pointer"
                  :class="{
                    'bg-primary-100 border border-primary-500': selectedPackageDelivery?.package?.id === service.package.id,
                    'bg-secondary-100 opacity-50 cursor-not-allowed':
                      parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight) ||
                      parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight) ||
                      parseInt(service.package.final_cost) <= 0
                  }"
                  :disabled="
                    parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight) ||
                      parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight) ||
                      parseInt(service.package.final_cost) <= 0
                  "
                  v-for="(service, idx) in value.package"
                  @click="
                    parseInt(shippingInfo?.receiver?.weight) >= parseInt(service.package.minimum_weight) &&
                    parseInt(shippingInfo?.receiver?.weight) <= parseInt(service.package.maximum_weight) &&
                    parseInt(service.package.final_cost) > 0
                      ? selectPackage(service.package, service)
                      : null
                  "
                  :key="'service' + idx"
                >
                  <div class="flex gap-2 items-center">
                    <div class="flex justify-start items-center w-20">
                      <img :src="service.logo" :alt="service.name" class="max-h-12" v-if="service.logo" />
                      <LogisticPlaceholder :logisticName="service.name" v-else />
                    </div>
                    <p class="text-sm">
                      {{ service.package.name }}
                      <template v-if="parseInt(service.package.final_cost) <= 0">
                        <p class="text-xs text-red-500">{{ $t('order.createOrder.stepTwo.unavailableService') }}</p>
                      </template>
                      <template v-else-if="parseInt(shippingInfo?.receiver?.weight) < parseInt(service.package.minimum_weight)">
                        <p class="text-xs">
                          {{ $t('order.createOrder.stepTwo.minimumWeight') }} {{ service.package.name }} {{ service.package.minimum_weight }} Kg,
                          {{ $t('order.createOrder.stepTwo.adjustWeight') }}
                        </p>
                      </template>
                      <template v-else-if="parseInt(shippingInfo?.receiver?.weight) > parseInt(service.package.maximum_weight)">
                        <p class="text-xs">
                          {{ $t('order.createOrder.stepTwo.maximumWeight') }} {{ service.package.name }} {{ service.package.maximum_weight }} Kg,
                          {{ $t('order.createOrder.stepTwo.adjustWeight') }}
                        </p>
                      </template>
                    </p>
                  </div>
                  <div class="flex flex-col gap-1 justify-end items-end" v-if="parseInt(service.package.final_cost) > 0">
                    <p class="flex items-center gap-2">
                      <Time /> <span class="text-xs text-neutral-500">{{ service.package.est_delivery_time_range_min }} - {{ service.package.est_delivery_time_range_max }}</span>
                    </p>
                    <p class="text-xs text-neutral-500 line-through" v-if="service.package.final_cost !== service.package.shipment_cost">
                      {{ service.package.shipment_cost | currencyFormat }}
                    </p>
                    <p class="text-sm font-medium">
                      {{ service.package.final_cost | currencyFormat }}
                      <template v-if="shippingInfo.is_require_pod">&nbsp;+&nbsp;{{ service.package?.return_delivery_service_packages[0]?.final_cost | currencyFormat }} </template>
                    </p>
                  </div>
                </div>
                <p class="text-red-500 text-sm italic" v-if="key === 'Sameday' && isAfterCutoff">{{ $t('order.createOrder.stepTwo.cutOffNote') }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="text-sm text-center py-4">- {{ $t('order.createOrder.stepTwo.noService') }} -</p>
          </template>
        </div>
      </div>
      <div class="w-3/5 p-6 mdmax:w-full mdmax:px-4">
        <div class="sticky-element">
          <!-- Rincian Paket - Selalu Tampil -->
          <div class="border border-neutral-300 mb-6 rounded-md bg-white shadow-sm">
            <div class="p-4 bg-neutral-200 rounded-t-md border-b border-neutral-300 flex items-center gap-2">
              <Box2 color="neutral-700" width="18" height="18" />
              <p class="font-bold text-sm text-neutral-700">Rincian Paket</p>
            </div>
            <div class="p-4 flex flex-col gap-3">
              <div class="flex justify-between items-center">
                <p class="text-sm text-neutral-500">Jenis Paket</p>
                <p class="text-sm font-medium">{{ selectedPackageCategory?.name || '-' }}</p>
              </div>
              <div class="flex justify-between items-center">
                <p class="text-sm text-neutral-500">Berat (Input)</p>
                <p class="text-sm font-medium">{{ shippingInfo?.receiver?.weight || 0 }} Kg</p>
              </div>
              <div class="flex justify-between items-center" v-if="shippingInfo?.package?.dimension">
                <p class="text-sm text-neutral-500">Dimensi Paket</p>
                <p class="text-sm font-medium">{{ shippingInfo.package.dimension.replace(/x/g, ' x ') }} cm</p>
              </div>
              <div class="flex justify-between items-center" v-if="volumetricWeight > 0">
                <p class="text-sm text-neutral-500">Berat Volume</p>
                <p class="text-sm font-medium">{{ volumetricWeight }} Kg</p>
              </div>
            </div>
          </div>


          <template v-if="shippingInfo.is_advance_pickup">
            <div class="border border-neutral-300 mb-6 rounded-md bg-neutral-200 p-4">
              <p class="text-xs mb-1">{{ $t('order.createOrder.stepTwo.pickupLater') }}</p>
              <p class=" font-semibold">{{ shippingInfo.pickup_date | formatDate }}, {{ shippingInfo?.pickup_slot_id?.display }} WIB</p>
            </div>
            <div class="text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md mb-6">
              <Info width="24" height="24" color="neutral-700" />{{ $t('order.createOrder.stepTwo.pickupLaterText') }}
            </div>
          </template>
          <p class="font-bold mb-4">{{ $t('order.createOrder.stepTwo.senderInformation') }}</p>
          <div class="border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6">
            <p class="font-bold mb-1">{{ shippingInfo?.sender?.sender_name }}</p>
            <p class="text-xs text-neutral-500">{{ shippingInfo?.sender?.address }}</p>
            <p class="bg-white p-2 mt-4" v-if="shippingInfo?.sender?.detail_address">
              <span class="block text-xs font-medium mb-1 text-neutral-500">{{ $t('order.createOrder.stepTwo.senderDetailAddress') }}</span>
              <span class="text-xs text-neutral-500">{{ shippingInfo?.sender?.detail_address }}</span>
            </p>
          </div>
          <div v-if="isPOD" class="mb-6 flex items-center gap-4 w-full">
            <div class="text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md">
              <Info width="24" height="24" color="neutral-700" />{{ $t('order.createOrder.stepTwo.pod') }}
            </div>
          </div>
          <div v-if="isPOD" class="border border-neutral-300 rounded-md mb-6">
            <div v-if="selectedPODService" class="p-4 bg-neutral-200 rounded-tl-md rounded-tr-md flex justify-between items-center mdmax:items-start">
              <div class="flex items-center gap-6 mdmax:flex-col mdmax:gap-1 mdmax:items-start">
                <img :src="selectedPackageDelivery.serviceLogo" class="w-20" v-if="selectedPackageDelivery.serviceLogo" />
                <LogisticPlaceholder :logisticName="selectedPackageDelivery.serviceName" v-else />
                <p class="bg-secondary-200 text-xs text-secondary-500 px-2 py-1 rounded-md">{{ selectedPODService.name }}</p>
              </div>
              <div class="flex flex-col gap-1">
                <p class="flex items-center gap-2">
                  <Time />
                  <span class="text-xs text-neutral-500">{{ selectedPODService.est_delivery_time_range_min }} - {{ selectedPODService.est_delivery_time_range_max }}</span>
                </p>
                <p class="text-xs text-neutral-500 line-through" v-if="selectedPODService.final_cost !== selectedPODService.shipment_cost">
                  {{ selectedPODService.shipment_cost | currencyFormat }}
                </p>
                <p class="text-sm font-medium">{{ selectedPODService.final_cost | currencyFormat }}</p>
              </div>
            </div>
            <div class="flex items-center gap-5 p-4 justify-between">
              <div class="flex gap-5 items-center">
                <Mail />
                <div>
                  <p class="text-sm font-medium">Surat Jalan (POD)</p>
                  <p class="text-xs text-neutral-500">0.5kg</p>
                </div>
              </div>
              <Button buttonText="Ubah Layanan" size="small" v-if="selectedPODService" @action="togglePOD()" />
            </div>
          </div>
          <p class="font-bold mb-4">{{ $t('order.createOrder.stepTwo.receiverInformation') }}</p>
          <div class="border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6">
            <p class="font-bold mb-1">{{ shippingInfo?.receiver?.name }}</p>
            <p class="text-xs text-neutral-500">{{ shippingInfo?.receiver?.addressDetail }}, {{ shippingInfo?.hub.destination.village }}, {{ shippingInfo?.hub.destination.area_display }}.</p>
          </div>
          <template v-if="selectedPackageDelivery?.package?.service_type === 'D' && nearestHubInfo">
            <p class="font-bold mb-4">Layanan Pick up</p>
            <div class="border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6">
              <p class="text-xs text-neutral-500 mb-1">Hub Terdekat</p>
              <p class="text-sm font-medium mb-1">{{ nearestHubInfo.name }}</p>
              <p class="text-xs">{{ nearestHubInfo.address }}</p>
            </div>
            <div class="border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6 flex justify-between items-center">
              <div class="flex flex-col gap-1">
                <p class="text-sm font-medium">Pilih Kendaraan Pickup</p>
                <p class="text-xs text-neutral-500">Lebih dari 50kg, rekomendasikan roda emapat</p>
              </div>
              <span @click="togglePickupVehicle()" class="cursor-pointer">
                <Chevron width="14" height="14" direction="right" />
              </span>
            </div>
          </template>
        </div>
    </div>
    </div>

    <div class="flex items-center p-6 justify-start bg-white gap-4 border-t border-neutral-200 mt-6">
      <Button :buttonText="$t('order.createOrder.stepTwo.back')" type="secondary" @action="goBack('shipping')" />
    </div>

    <!-- Checkout / Payment Modal -->
    <Modal :modalVisible="showCheckoutModal" @close="showCheckoutModal = false" id="checkout-modal" width="550px" :overflowAuto="true">
      <template slot="modal-content">
        <div class="flex justify-between items-center mb-6 border-b border-neutral-200 pb-4">
          <p class="font-bold text-xl text-neutral-800">Rincian & Pembayaran</p>
        </div>

        <!-- Ekspedisi Info -->
        <div class="border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm" v-if="selectedPackageDelivery">
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-4">
              <div class="w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1">
                <img :src="selectedPackageDelivery.serviceLogo" class="max-h-10 object-contain" v-if="selectedPackageDelivery.serviceLogo" />
                <LogisticPlaceholder :logisticName="selectedPackageDelivery.serviceName" v-else />
              </div>
              <div>
                <p class="font-bold text-neutral-800 text-sm">{{ selectedPackageDelivery.package.name }}</p>
                <p class="text-xs text-neutral-500 mt-1 flex items-center gap-1 font-medium">
                  <Time width="12" height="12" color="neutral-500" /> {{ selectedPackageDelivery.package.est_delivery_time_range_min }} - {{ selectedPackageDelivery.package.est_delivery_time_range_max }}
                </p>
              </div>
            </div>
            <div class="text-right">
              <p class="text-base font-bold text-primary-600">{{ selectedPackageDelivery.package.final_cost | currencyFormat }}</p>
            </div>
          </div>

          <!-- Lion Parcel Pickup Location Display/Edit -->
          <div v-if="isLionParcel()" class="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center text-xs">
            <div class="flex items-center gap-1.5 text-neutral-600">
              <span class="font-semibold text-neutral-700">Titik Jemput:</span>
              <span v-if="hasValidSenderCoordinate()" class="text-neutral-500">{{ shippingInfo?.sender?.location_coordinate }}</span>
              <span v-else class="text-red-500 font-medium">Belum diatur</span>
            </div>
            <button
              type="button"
              @click="openMapModal()"
              class="text-primary-600 hover:text-primary-700 font-semibold underline text-xs cursor-pointer"
            >
              {{ hasValidSenderCoordinate() ? 'Ubah Lokasi' : 'Pilih Lokasi' }}
            </button>
          </div>
        </div>

        <!-- Asuransi -->
        <div v-if="selectedPackageDelivery && selectedPackageDelivery.package.has_insurace" class="border border-gray-300 mb-6 rounded-xl overflow-hidden shadow-sm bg-white">
          <div class="p-4 flex justify-between items-center gap-4" :class="{ 'border-b border-gray-300 bg-neutral-50': insurance }">
            <div class="flex flex-col flex-1">
              <p class="text-sm font-bold text-neutral-800">{{ $t('order.createOrder.stepTwo.insurance') }}</p>
              <p class="text-xs text-neutral-500 mt-1" v-if="!insurance">Lindungi paket dari kerusakan/kehilangan</p>
            </div>
            <div class="w-12 flex-shrink-0 flex justify-end">
              <Toggle id="insurance" v-model="insurance" />
            </div>
          </div>
          <div class="p-4 bg-white" v-if="insurance">
            <label class="text-sm text-neutral-700 font-medium mb-2 block">
              {{ $t('order.createOrder.stepTwo.goodsValue') }}
            </label>
            <CurrencyInput :ref="'priceField'" :options="{ currency: 'IDR' }" @change="goodsValue = $event" :placeholder="$t('order.createOrder.stepTwo.goodsValuePlaceholder')" />
            <div class="mt-4 pt-4 border-t border-dashed border-neutral-200 flex justify-between items-center">
              <p class="text-sm text-neutral-600">{{ $t('order.createOrder.stepTwo.insuranceCost') }}</p>
              <p class="text-sm font-bold text-neutral-800">{{ costOfInsurance | currencyFormat }}</p>
            </div>
          </div>
        </div>

        <!-- Rincian Biaya -->
        <div class="border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm">
          <p class="font-bold text-sm mb-4 text-neutral-800">Rincian Biaya</p>
          <div class="flex justify-between items-center mb-3">
            <p class="text-sm text-neutral-500">Layanan Pengiriman</p>
            <p class="text-sm font-medium text-neutral-800">{{ selectedPackageDelivery?.package?.final_cost | currencyFormat }}</p>
          </div>
          <div class="flex justify-between items-center mb-3" v-if="insurance">
            <p class="text-sm text-neutral-500">Biaya Asuransi</p>
            <p class="text-sm font-medium text-neutral-800">{{ costOfInsurance | currencyFormat }}</p>
          </div>
          <div class="flex justify-between items-center mb-3" v-if="shippingInfo?.is_require_pod && selectedPODService">
            <p class="text-sm text-neutral-500">Biaya Surat Jalan (POD)</p>
            <p class="text-sm font-medium text-neutral-800">{{ selectedPODService.final_cost | currencyFormat }}</p>
          </div>
          <div class="border-t border-gray-300 mt-4 pt-4 flex justify-between items-center bg-primary-50 -mx-4 -mb-4 px-4 py-3 rounded-b-xl">
            <p class="font-bold text-neutral-800">Total Pembayaran</p>
            <p class="font-bold text-lg text-primary-600">{{ totalCost | currencyFormat }}</p>
          </div>
        </div>

        <!-- Metode Pembayaran -->
        <div class="mb-6" v-if="!user?.is_upgraded">
          <p class="font-bold text-sm mb-3 text-neutral-800">Metode Pembayaran</p>
          <div class="flex gap-4">
            <div class="border rounded-xl p-4 flex-1 flex items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-md" :class="{'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': paymentType === 'qris', 'border-gray-300 bg-white hover:border-primary-300': paymentType !== 'qris'}" @click="paymentType = 'qris'">
              <label class="flex flex-col items-center gap-2 w-full cursor-pointer">
                <input type="radio" name="paymentTypeModal" value="qris" v-model="paymentType" class="hidden" />
                <img src="@/assets/images/icons/qris.svg" class="h-6 object-contain" />
                <span class="text-xs font-medium text-neutral-600" :class="{'text-primary-700': paymentType === 'qris'}">QRIS</span>
              </label>
            </div>
            <div class="border rounded-xl p-4 flex-1 flex flex-col justify-center cursor-pointer transition-all duration-200 hover:shadow-md" :class="{'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': paymentType === 'transfer', 'opacity-50 cursor-not-allowed bg-neutral-50': totalCost < 80000, 'border-gray-300 bg-white hover:border-primary-300': paymentType !== 'transfer' && totalCost >= 80000}" @click="totalCost >= 80000 ? paymentType = 'transfer' : null">
              <label class="flex flex-col items-center gap-2 w-full cursor-pointer" :class="{'cursor-not-allowed': totalCost < 80000}">
                <input :disabled="totalCost < 80000" type="radio" name="paymentTypeModal" value="transfer" v-model="paymentType" class="hidden" />
                <span class="font-bold text-sm text-neutral-700" :class="{'text-primary-700': paymentType === 'transfer'}">Bank Transfer</span>
              </label>
              <p class="text-red-500 text-[10px] mt-1 text-center w-full" v-if="totalCost < 80000">
                Min. Belanja Rp 80.000
              </p>
            </div>
          </div>
        </div>

        <div v-if="isLionParcelMissingCoord" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center justify-between text-xs text-red-700">
          <span>Lion Parcel mewajibkan penentuan titik jemput pada peta.</span>
          <button type="button" @click="openMapModal()" class="font-bold underline ml-2 whitespace-nowrap">Pilih Lokasi</button>
        </div>

        <div class="mt-4 pt-6 pb-2 border-t border-gray-200">
          <Button :disabled="(!user?.is_upgraded && !paymentType) || isLionParcelMissingCoord" buttonText="Lanjutkan Pembayaran" type="primary" size="big_full" @action="submitOrderModal()" />
        </div>
      </template>
    </Modal>

    <!-- Confirmation Modal (VIP) -->
    <Modal :modalVisible="showConfirmModal" @close="showConfirmModal = false" id="confirm-vip-modal" width="400px">
      <template slot="modal-content">
        <h2 class="text-lg font-bold mb-4">Konfirmasi Pembayaran</h2>
        <p class="text-sm mb-6">Apakah anda ingin melanjutkan proses pembayaran?</p>
        <div class="flex justify-end gap-4">
          <Button buttonText="Batal" type="secondary" size="small" @action="showConfirmModal = false" />
          <Button buttonText="Ya, Bayar" type="primary" size="small" @action="confirmVIPPayment" />
        </div>
      </template>
    </Modal>

    <!-- Map Modal -->
    <Modal :modalVisible="showMapModal" @close="cancelMapModal" width="600px" id="map-modal">
      <template slot="modal-content">
        <h3 class="font-bold text-lg mb-2 text-neutral-800">Tentukan Lokasi Penjemputan</h3>
        <p class="text-sm text-neutral-600 mb-4">Lion Parcel mewajibkan koordinat lokasi untuk memproses pengiriman. Silakan pin lokasi pengirim pada peta di bawah ini.</p>
        
        <!-- Search bar map -->
        <div class="mb-3 relative">
          <input
            v-model="placeSearch"
            @input="searchPlaces"
            type="text"
            placeholder="Cari lokasi pengirim..."
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm"
          />
          <ul v-if="placeSuggestions.length > 0" class="absolute z-20 w-full bg-white border border-gray-200 mt-1 rounded-md shadow-lg max-h-60 overflow-y-auto">
            <li v-for="(prediction, index) in placeSuggestions" :key="index" @click="selectPlaceMap(prediction)" class="px-4 py-2.5 hover:bg-neutral-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0">
              {{ prediction.description }}
            </li>
          </ul>
        </div>
        
        <div style="height: 320px; width: 100%;" class="mb-3 rounded-lg overflow-hidden border border-neutral-300">
          <GmapMap :center="mapCenter" :zoom="mapZoom" style="width: 100%; height: 100%;" @click="updateMarkerPosition" :options="{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false }">
            <GmapMarker :position="mapCenter" :draggable="true" @dragend="updateMarkerPosition" />
          </GmapMap>
        </div>

        <div class="text-xs text-neutral-500 text-center mb-5">
          <span class="font-semibold text-neutral-700">Koordinat:</span> {{ mapCenter.lat.toFixed(6) }}, {{ mapCenter.lng.toFixed(6) }}
        </div>
        
        <div class="flex justify-end gap-3">
          <Button buttonText="Batal" type="secondary" size="regular" @action="cancelMapModal" />
          <Button :buttonText="isConfirmingLocation ? 'Menyimpan...' : 'Simpan Lokasi'" :disabled="isConfirmingLocation" type="primary" size="regular" @action="saveLocation" />
        </div>
      </template>
    </Modal>

    <Modal :modalVisible="visibleVehicleModal" @close="togglePickupVehicle" id="vehicle-modal" width="600px">
      <template slot="modal-content">
        <VehicleSelection
          :nearestHub="nearestHubInfo"
          @pickup="setPickup"
          @close="togglePickupVehicle"
          :shippingInfo="shippingInfo"
          :deliveryServiceId="selectedPackageDelivery?.package?.delivery_service_id"
        />
      </template>
    </Modal>
    <Modal :modalVisible="visiblePODOptions" @close="togglePOD()" id="pod-modal" width="600px">
      <template slot="modal-content">
        <p class="text-left font-bold text-2xl mb-6">Layanan {{ selectedPackageDelivery?.serviceName }}</p>

        <div
          class="flex justify-between items-center shadow-border py-2 px-4 rounded-md mb-3 last:mb-0 cursor-pointer"
          :class="{ 'bg-primary-100 border border-primary-500': temporaryPOD?.id === pod.id }"
          v-for="(pod, idx) in selectedPackageDelivery?.package?.return_delivery_service_packages"
          @click="selectPOD(pod)"
          :key="'pod' + idx"
        >
          <div class="flex gap-2 items-center">
            <div class="flex justify-start items-center w-20">
              <img :src="selectedPackageDelivery?.serviceLogo" :alt="pod.name" class="max-h-12" v-if="selectedPackageDelivery?.serviceLogo" />
              <LogisticPlaceholder :logisticName="pod.name" v-else />
            </div>
            <p class="text-sm">
              {{ pod.name }}
            </p>
          </div>
          <div class="flex flex-col gap-1 justify-end items-end">
            <p class="flex items-center gap-2">
              <Time /> <span class="text-xs text-neutral-500">{{ pod.est_delivery_time_range_min }} - {{ pod.est_delivery_time_range_max }}</span>
            </p>
            <p class="text-xs text-neutral-500 line-through" v-if="pod.final_cost !== pod.shipment_cost">{{ pod.shipment_cost | currencyFormat }}</p>
            <p class="text-sm font-medium">
              {{ pod.final_cost | currencyFormat }}
            </p>
          </div>
        </div>
        <div class="mt-6 flex justify-end items-center gap-4">
          <Button buttonText="Batal" type="secondary" size="regular" @action="togglePOD()" />
          <Button buttonText="Ubah" size="regular" @action="applyPOD()" />
        </div>
      </template>
    </Modal>


  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { currencyFormat, formatDate } from '@/util'
export default {
  filters: {
    currencyFormat,
    formatDate
  },
  components: {
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Info: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Info'),
    // Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    LogisticPlaceholder: () => import(/* webpackChunkName: "LogisticPlaceholder" */ '@/components/Icons/LogisticPlaceholder'),
    Box2: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Box2'),
    Mail: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Mail'),
    Time: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Time'),
    Chevron: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Chevron'),
    // Place: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Place'),
    // Search: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Search'),
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    // Info: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Info'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    VehicleSelection: () => import(/* webpackChunkName: "Modal" */ '@/views/Order/VehicleSelection'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Toggle: () => import(/* webpackChunkName: "Toggle" */ '@/components/Toggle/Toggle'),
    CurrencyInput: () => import(/* webpackCunkName: "CurrencyInput" */ '@/components/Forms/CurrencyInput')
    // VueGoogleAutocomplete
  },
  data: () => ({
    isPOD: false,
    shippingInfo: null,
    logisticInfo: null,
    nearestHubInfo: null,
    selectedPackageCategory: null,
    deliveryServiceTypeList: [
      {
        name: 'Semua Layanan',
        value: ''
      },
      {
        name: 'Pickup & Drop Off',
        value: 'A'
      },
      {
        name: 'Pickup',
        value: 'P'
      },
      {
        name: 'Drop Off',
        value: 'D'
      }
    ],
    selectedServicePackage: {
      name: 'Semua Layanan',
      value: ''
    },
    selectedDeliveryService: {
      name: 'Semua'
    },
    receiverName: null,
    receiverPhoneNumber: null,
    goodsWeight: null,
    addressDetail: null,
    packageList: ['a', 'b'],
    selectedPackage: null,
    selectedPackageDelivery: null,
    visibleVehicleModal: false,
    selectedPickupAgent: null,
    searchKeyword: null,
    isSearchingPlace: false,
    selectedPackageSize: null,
    isFetching: false,
    insurance: false,
    goodsValue: null,
    showCheckoutModal: false,
    showConfirmModal: false,
    showMapModal: false,
    paymentType: null,
    placeSearch: '',
    placeSuggestions: [],
    mapCenter: { lat: -6.200000, lng: 106.816666 }, // default to Jakarta
    mapZoom: 15,
    placeSearchDebounce: null,
    isConfirmingLocation: false,
    payloads: {
      name: '',
      location: '',
      email: '',
      origin_city: null,
      destination_city: null
    },
    debounce: null,
    origin: '',
    originSearch: '',
    destination: '',
    destinationSearch: '',
    cityKeyword: null,
    visibleSuggestion: {
      origin: false,
      destination: false
    },
    isSearching: {
      origin: false,
      destination: false
    },
    orderStep: ['shipping', 'logistic', 'confirmation'],
    address: null,
    autocomplete: null,
    autocompleteService: null,
    placeService: null,
    sessionToken: null,
    suggestionList: [],
    deliveryServiceByGroup: {
      Regular: {
        isVisible: false,
        package: []
      },
      Sameday: {
        isVisible: false,
        package: []
      },
      Express: {
        isVisible: false,
        package: []
      },
      Ekonomi: {
        isVisible: false,
        package: []
      },
      Cargo: {
        isVisible: false,
        package: []
      }
    },
    recommendedDeliveryServices: [],
    localStorageAsync: {
      set: function(key, value) {
        return Promise.resolve().then(function() {
          localStorage.setItem(key, value)
        })
      },
      get: function(key) {
        return Promise.resolve().then(function() {
          return localStorage.getItem(key)
        })
      }
    },
    selectedPODService: null,
    visiblePODOptions: false,
    temporaryPOD: null
  }),
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('master', ['cities', 'packageSizes', 'goodsCategories']),
    ...mapGetters('merchant', ['addresses', 'deliveryServices', 'nearestHub']),
    ...mapGetters('common', ['isMobile']),
    isStepAvailable() {
      return this.orderStep.indexOf(this.$route.params.step) > -1
    },
    defaultAddress() {
      return this.addresses[0]
    },
    isFirstStep() {
      return this.$route.params.step === 'shipping'
    },
    isSecondStep() {
      return this.$route.params.step === 'logistic'
    },
    isThirdStep() {
      return this.$route.params.step === 'confirmation'
    },
    isDisabled() {
      return !this.selectedPackageDelivery
    },
    totalCost() {
      let cost = this.selectedPackageDelivery?.package?.final_cost || 0
      if (this.insurance) {
        cost += this.costOfInsurance
      }
      if (this.shippingInfo?.is_require_pod && this.selectedPODService) {
        cost += this.selectedPODService.final_cost || 0
      }
      return cost
    },
    user() {
      return this.userData?.user
    },
    isLionParcelMissingCoord() {
      return this.isLionParcel() && !this.hasValidSenderCoordinate()
    },
    costOfInsurance() {
      if (!this.insurance) return 0

      if (this.selectedPackageDelivery.serviceName.includes('JNE')) {
        return Math.ceil(this.goodsValue * 0.002 + 5000)
      }
      if (this.selectedPackageDelivery.serviceName.toLowerCase().includes('lion')) {
        return Math.ceil((this.goodsValue * 0.27) / 100)
      }
      if (this.selectedPackageDelivery.serviceName.includes('J&T Cargo')) {
        if (this.goodsValue <= 2500000) {
          return 5000
        }
        return Math.ceil(this.goodsValue * 0.002)
      }
      if (this.goodsValue >= 1000000) {
        return Math.ceil(this.goodsValue * 0.0025)
      }
      return 2500
    },
    isAfterCutoff() {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      // true if 12:00 or later
      return hours > 14 || (hours === 14 && minutes >= 0)
    },
    volumetricWeight() {
      if (this.shippingInfo?.package?.dimension) {
        const dims = this.shippingInfo.package.dimension.split('x')
        if (dims.length === 3) {
          const p = parseFloat(dims[0])
          const l = parseFloat(dims[1])
          const t = parseFloat(dims[2])
          return Math.ceil((p * l * t) / 6000)
        }
      }
      return 0
    }
  },
  mounted() {
    this.checkLionParcelLocation()
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  created() {
    const shipping = localStorage.getItem('order_shipping')
    if (shipping) {
      this.shippingInfo = JSON.parse(shipping)
      if (this.shippingInfo?.sender) {
        const normSenderPhone = this.normalizePhoneNumber(this.shippingInfo.sender.sender_phone || this.shippingInfo.sender.phone)
        this.shippingInfo.sender.sender_phone = normSenderPhone
        this.shippingInfo.sender.phone = normSenderPhone
      }
      if (this.shippingInfo?.receiver) {
        const normRecPhone = this.normalizePhoneNumber(this.shippingInfo.receiver.phone)
        this.shippingInfo.receiver.phone = normRecPhone
      }
      this.isPOD = this.shippingInfo.is_require_pod
      // if(this.isPOD) this.selectedPODService = this.shi
      this.getDeliveryServicesInfo()
    }
    this.getGoodsCategoryList()
  },
  methods: {
    ...mapActions('master', ['getCities', 'getPackageSizes', 'getGoodsCategories']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    ...mapActions('merchant', ['getAddresses', 'getDeliveryServices', 'getNearestHub', 'createOrder']),
    normalizePhoneNumber(phone) {
      if (!phone) return ''
      let digits = String(phone).replace(/\D/g, '')
      if (digits.startsWith('0062')) {
        digits = digits.slice(4)
        if (digits.startsWith('0')) digits = digits.slice(1)
        digits = '0' + digits
      } else if (digits.startsWith('620')) {
        digits = '0' + digits.slice(3)
      } else if (digits.startsWith('62')) {
        digits = '0' + digits.slice(2)
      } else if (digits.startsWith('8')) {
        digits = '0' + digits
      }
      return digits
    },
    submitOrderModal() {
      if (this.isLionParcelMissingCoord) {
        this.openMapModal()
        return
      }

      if (this.user?.is_upgraded) {
        this.showConfirmModal = true
      } else {
        this.processSubmitOrder()
      }
    },
    confirmVIPPayment() {
      this.showConfirmModal = false
      this.processSubmitOrder()
    },
    processSubmitOrder() {
      const payloads = {
        is_advance_pickup: this.shippingInfo.is_advance_pickup,
        is_require_pod: this.shippingInfo.is_require_pod,
        sender: {
          name: this.shippingInfo?.sender?.sender_name,
          phone_number: this.normalizePhoneNumber(this.shippingInfo?.sender?.sender_phone || this.shippingInfo?.sender?.phone),
          location_code: this.shippingInfo?.hub?.origin?.code,
          location_coordinate: this.shippingInfo?.sender?.location_coordinate,
          address: this.shippingInfo?.sender?.address,
          detail_address: this.shippingInfo?.sender?.detail_address
        },
        service_id: this.selectedPackageDelivery?.package?.delivery_service_id,
        service_type: this.selectedPackageDelivery?.package?.service_type,
        service_category: 'REG',
        service_package_id: this.selectedPackageDelivery?.package?.id,
        order_type: 'DELPKG',
        packages: [
          {
            category: this.shippingInfo?.hub?.goodsCategory,
            dimension: this.shippingInfo?.package.dimension,
            dimension_type: this.shippingInfo?.package.code,
            weight: parseFloat(this.shippingInfo?.receiver?.weight || 0),
            has_dangerous_goods: false,
            has_glass: false,
            goods_description: '',
            has_high_value: false,
            has_document: false,
            has_electronic: false,
            receiver: {
              name: this.shippingInfo?.receiver?.name,
              phone_number: this.normalizePhoneNumber(this.shippingInfo?.receiver?.phone),
              location_code: this.shippingInfo?.hub?.destination?.code,
              location_coordinate: `${this.shippingInfo?.receiver?.location?.latitude},${this.shippingInfo?.receiver?.location?.longitude}`,
              address: this.shippingInfo?.receiver?.addressDetail,
              detail_address: ''
            }
          }
        ],
        pickup_detail: {
          service_id: this.selectedPickupAgent?.delivery_service_id || '',
          service_package_id: this.selectedPickupAgent?.id || '',
          pickup_time: this.selectedPickupAgent ? new Date(new Date().getTime() + 60*60*1000).toISOString() : ''
        },
        transit_detail: {
          transit_place_id: this.nearestHubInfo?.id || '',
          place_location_code: this.nearestHubInfo?.area_code,
          place_location_coords: this.nearestHubInfo ? `${this.nearestHubInfo?.coord_lat}, ${this.nearestHubInfo?.coord_lng}` : ''
        },
        goods_value: this.goodsValue,
        insurance_cost: this.costOfInsurance,
        enabled_payments: this.paymentType
      }

      if (this.shippingInfo.is_advance_pickup) {
        payloads.pickup_slot_id = this.shippingInfo?.pickup_slot_id?.id
        payloads.pickup_date = this.shippingInfo.pickup_date
      }

      if (this.shippingInfo.is_require_pod) {
        payloads.pod = {
          service_package_id: this.selectedPODService?.id,
          service_id: this.selectedPackageDelivery?.package?.delivery_service_id
        }
      }

      this.showLoading()
      this.createOrder({ payloads }).then(res => {
        this.hideLoading()
        this.showCheckoutModal = false
        if (res.data.data.is_advance_payment) {
          this.handlePay(res.data.data)
        } else {
          this.$router.push(`/order/detail/${res.data.data.order_id}`)
        }
      }).catch(() => {
        this.hideLoading()
      })
    },
    handlePay(response) {
      const self = this
      this.localStorageAsync.set('order', JSON.stringify(response))
      this.localStorageAsync.set('payment_finish_url', JSON.stringify(response.payment_finish_url))
      window.snap.pay(response.payment_token, {
        onSuccess: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onPending: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onError: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onClose: function() {
          console.log('customer closed the popup')
        }
      })
    },
    isLionParcel(serviceName) {
      const name = (serviceName || this.selectedPackageDelivery?.serviceName || this.selectedPackageDelivery?.package?.name || '').toLowerCase()
      return name.includes('lion')
    },
    hasValidSenderCoordinate() {
      const coord = this.shippingInfo?.sender?.location_coordinate
      if (!coord || typeof coord !== 'string') return false
      const trimmed = coord.trim()
      if (!trimmed || trimmed === 'lat,long') return false
      const parts = trimmed.split(',')
      if (parts.length !== 2) return false
      const lat = parseFloat(parts[0])
      const lng = parseFloat(parts[1])
      if (isNaN(lat) || isNaN(lng)) return false
      if (lat === 0 && lng === 0) return false
      return true
    },
    checkLionParcelLocation() {
      if (this.isLionParcelMissingCoord) {
        this.openMapModal()
      }
    },
    openMapModal() {
      if (this.hasValidSenderCoordinate()) {
        const coords = this.shippingInfo.sender.location_coordinate.split(',')
        this.mapCenter = {
          lat: parseFloat(coords[0]),
          lng: parseFloat(coords[1])
        }
        this.mapZoom = 16
      } else {
        this.getUserLocation()
      }
      this.showMapModal = true
    },
    cancelMapModal() {
      this.showMapModal = false
      if (this.isLionParcel() && !this.hasValidSenderCoordinate()) {
        this.selectedPackageDelivery = null
      }
    },
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.mapCenter = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            this.mapZoom = 16
          },
          error => {
            console.error('Error getting location:', error)
          }
        )
      }
    },
    handleClickOutside(event) {
      const modalEl = document.getElementById('map-modal')
      if (modalEl) {
        const inputEl = modalEl.querySelector('input')
        const listEl = modalEl.querySelector('ul')
        if (inputEl && !inputEl.contains(event.target) && listEl && !listEl.contains(event.target)) {
          this.placeSuggestions = []
        }
      }
    },
    updateMarkerPosition(event) {
      this.mapCenter = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      this.placeSuggestions = []
    },
    searchPlaces() {
      clearTimeout(this.placeSearchDebounce)
      if (!this.placeSearch || this.placeSearch.length < 3) {
        this.placeSuggestions = []
        return
      }
      this.placeSearchDebounce = setTimeout(() => {
        if (!window.google || !window.google.maps) return
        const service = new window.google.maps.places.AutocompleteService()
        service.getPlacePredictions(
          {
            input: this.placeSearch,
            componentRestrictions: { country: 'id' }
          },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
              this.placeSuggestions = predictions
            } else {
              this.placeSuggestions = []
            }
          }
        )
      }, 300)
    },
    selectPlaceMap(prediction) {
      this.placeSearch = prediction.description
      this.placeSuggestions = []
      
      if (window.google && window.google.maps) {
        const service = new window.google.maps.places.PlacesService(document.createElement('div'))
        service.getDetails(
          {
            placeId: prediction.place_id,
            fields: ['geometry']
          },
          (placeDetails, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && placeDetails.geometry) {
              this.mapCenter = {
                lat: placeDetails.geometry.location.lat(),
                lng: placeDetails.geometry.location.lng()
              }
              this.mapZoom = 17
            }
          }
        )
      }
    },
    saveLocation() {
      this.isConfirmingLocation = true
      const newCoord = `${this.mapCenter.lat},${this.mapCenter.lng}`
      if (!this.shippingInfo) {
        this.shippingInfo = {}
      }
      if (!this.shippingInfo.sender) {
        this.shippingInfo.sender = {}
      }
      this.shippingInfo.sender.location_coordinate = newCoord
      
      // Update local storage
      const existingData = JSON.parse(localStorage.getItem('order_shipping') || '{}')
      if (!existingData.sender) {
        existingData.sender = {}
      }
      existingData.sender.location_coordinate = newCoord
      localStorage.setItem('order_shipping', JSON.stringify(existingData))
      
      this.showMapModal = false
      this.isConfirmingLocation = false

      this.setToast({
        options: {
          type: 'success',
          duration: 3000,
          primaryText: 'Titik jemput berhasil disimpan',
          secondaryText: `Koordinat: ${this.mapCenter.lat.toFixed(6)}, ${this.mapCenter.lng.toFixed(6)}`
        }
      })

      // Proceed to checkout modal
      if (this.selectedPackageDelivery) {
        if (this.shippingInfo.is_require_pod && this.selectedPackageDelivery.package?.return_delivery_service_packages?.length > 0) {
          this.selectedPODService = this.selectedPackageDelivery.package.return_delivery_service_packages[0]
        }
        if (this.selectedPackageDelivery.package?.service_type === 'D') {
          this.getNearestHubList()
        }
        this.showCheckoutModal = true
      }
    },
    saveLocationAndSubmit() {
      this.saveLocation()
    },

    applyPOD() {
      this.selectedPODService = this.temporaryPOD
      this.togglePOD()
    },
    selectPOD(pod) {
      this.temporaryPOD = pod
    },
    togglePOD() {
      this.visiblePODOptions = !this.visiblePODOptions
      this.temporaryPOD = this.selectedPODService
    },
    goToStep3() {
      let data = {
        logistic: this.selectedPackageDelivery,
        nearest_hub: null,
        pickup: null
      }
      if (this.insurance && this.goodsValue == null) {
        setTimeout(() => {
          this.$refs.priceField.focus()
        }, 50)
        alert('Silahkan isi harga barang')
        return false
      }
      if (this.selectedPackageDelivery?.package?.service_type === 'D') {
        data.nearest_hub = this.nearestHubInfo
        data.pickup = this.selectedPickupAgent
      }
      if (this.shippingInfo.is_require_pod) {
        data.selectedPODService = this.selectedPODService
      }
      if (this.insurance) {
        data.goodsValue = this.goodsValue
        data.insurance = this.insurance
        data.insuranceCost = this.costOfInsurance
      }
      this.showLoading()
      localStorage.removeItem('order')
      this.localStorageAsync.set('order_logistic', JSON.stringify(data)).then(() => {
        setTimeout(() => {
          this.hideLoading()
          this.$router.push(`/order/step/confirmation${this.$route.query.draft ? `?draft=${this.$route.query.draft}` : ''}`)
        }, 2000)
      })
    },
    setPickup(value) {
      this.selectedPickupAgent = value
      this.togglePickupVehicle()
    },
    togglePickupVehicle() {
      this.visibleVehicleModal = !this.visibleVehicleModal
    },
    getDeliveryServicesById() {
      this.getDeliveryServicesInfo(this.selectedDeliveryService.id)
    },
    getDeliveryServicesInfo(deliveryServiceId = '') {
      let self = this
      this.showLoading()
      this.getDeliveryServices({
        params: {
          page: 1,
          per_page: 10,
          search_keyword: '',
          sort: 'ASC',
          origin_city: self.shippingInfo.hub.origin.code,
          destination_city: self.shippingInfo.hub.destination.code,
          goods_category: self.shippingInfo.hub.goodsCategory,
          package_size: self.shippingInfo.package.dimension,
          delivery_service_id: deliveryServiceId,
          delivery_service_type: self.selectedServicePackage.value,
          package_size_type: self.shippingInfo.package.code,
          delivery_service_package: '',
          package_weight: self.shippingInfo.receiver.weight,
          is_require_pod: self.shippingInfo.is_require_pod
        }
      }).then(res => {
        this.hideLoading()
        this.groupDeliveryServices(res.data.data)
        const logistic = localStorage.getItem('order_logistic')
        if (logistic) {
          this.logisticInfo = JSON.parse(logistic)
          const savedPackageId = this.logisticInfo.logistic?.package?.id

          // Re-match selectedPackageDelivery with fresh API data
          if (savedPackageId) {
            let matchedService = null
            res.data.data.forEach(service => {
              service.packages.forEach(pkg => {
                if (pkg.id === savedPackageId) {
                  matchedService = {
                    package: pkg,
                    serviceLogo: service.logo,
                    serviceName: service.name
                  }
                }
              })
            })

            if (matchedService) {
              this.selectedPackageDelivery = matchedService
            } else {
              // Fallback to saved data if no match found
              this.selectedPackageDelivery = this.logisticInfo.logistic
            }
          } else {
            this.selectedPackageDelivery = this.logisticInfo.logistic
          }

          if (this.isPOD) this.selectedPODService = this.logisticInfo.selectedPODService
          this.nearestHubInfo = this.logisticInfo.nearest_hub
        }
      })
    },
    groupDeliveryServices(list) {
      const arrGroup = []
      this.recommendedDeliveryServices = []
      list.forEach(item => {
        item.packages.forEach(elem => {
          const constructedObject = {
            logo: item.logo,
            name: item.name,
            package: elem
          }
          if (item.name === 'ID Express') {
            const receiverWeight = parseInt(this.shippingInfo?.receiver?.weight || 0)
            const minWeight = parseInt(elem.minimum_weight || 0)
            const maxWeight = parseInt(elem.maximum_weight || 0)
            const finalCost = parseInt(elem.final_cost || 0)
            
            if (receiverWeight >= minWeight && receiverWeight <= maxWeight && finalCost > 0) {
              this.recommendedDeliveryServices.push(constructedObject)
            }
          } else {
            arrGroup.push(constructedObject)
          }
        })
      })
      this.deliveryServiceByGroup = arrGroup.reduce(function(r, a) {
        r[a.package.group_delivery] = r[a.package.group_delivery] || []
        r[a.package.group_delivery].push(a)
        return r
      }, Object.create(null))
      Object.keys(this.deliveryServiceByGroup).map((key, value) => {
        this.deliveryServiceByGroup[key] = {
          isVisible: false,
          package: this.deliveryServiceByGroup[key]
        }
      })
    },
    expand(key, visible) {
      this.deliveryServiceByGroup[key].isVisible = !visible
      Object.entries(this.deliveryServiceByGroup).map(([item]) => {
        if (item !== key) this.deliveryServiceByGroup[item].isVisible = false
      })
    },
    getServiceTypeName(value) {
      return this.deliveryServiceTypeList.filter(item => item.value === value)[0].name
    },
    selectPackage(item, service) {
      this.selectedPackageDelivery = {
        package: item,
        serviceLogo: service?.logo,
        serviceName: service?.name
      }
      if (this.shippingInfo?.is_require_pod && item?.return_delivery_service_packages?.length > 0) {
        this.selectedPODService = item.return_delivery_service_packages[0]
      }

      const isLion = this.isLionParcel(service?.name)
      if (isLion && !this.hasValidSenderCoordinate()) {
        this.openMapModal()
        return
      }

      if (this.selectedPackageDelivery?.package?.service_type === 'D') {
        this.getNearestHubList()
      }
      this.showCheckoutModal = true
    },
    getNearestHubList() {
      this.showLoading()
      this.getNearestHub({
        params: {
          deliveryserviceid: this.selectedPackageDelivery?.package?.delivery_service_id,
          coords: this.shippingInfo?.sender?.location_coordinate
        }
      }).then(() => {
        this.nearestHubInfo = this.nearestHub
        this.hideLoading()
      })
    },
    cancelCreateOrder() {
      this.showLoading()
      localStorage.removeItem('order_shipping')
      setTimeout(() => {
        this.hideLoading()
        this.$router.push('/order')
      }, 2000)
    },
    goBack(target) {
      this.showLoading()
      setTimeout(() => {
        this.$router.push(`/order/step/${target}${this.$route.query.draft ? `?draft=${this.$route.query.draft}` : ''}`)
        this.hideLoading()
      }, 1000)
    },
    getSenderAddress() {
      this.getAddresses({
        params: ''
      })
    },
    selectPackageSize(size) {
      this.selectedPackageSize = size
    },
    displaySuggestions(value) {
      this.suggestionList = value
    },
    searchPlace(input) {
      if (this.searchKeyword !== '') {
        clearTimeout(this.debounce)
        let self = this
        this.debounce = setTimeout(() => {
          if (this.searchKeyword !== '') {
            this.isSearchingPlace = true
            this.autocompleteService.getPlacePredictions(
              {
                input: self.searchKeyword,
                sessionToken: self.sessionToken,
                componentRestrictions: { country: 'id' }
              },
              this.displaySuggestions
            )
          }
        }, 300)
      } else {
        this.isSearchingPlace = false
      }
    },
    selectPlace(place) {
      let request = {
        placeId: place.place_id,
        fields: ['name', 'geometry', 'formatted_address']
      }
      this.autocompleteService.get
      this.searchKeyword = place.description
      this.isSearchingPlace = false
      this.placeService.getDetails(request, this.setAddress)
    },
    setAddress(place) {
      this.address = {
        name: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }
    },
    async goToStep2() {
      let data = {
        sender: this.defaultAddress,
        receiver: {
          name: this.receiverName,
          phone: this.receiverPhoneNumber,
          weight: this.goodsWeight,
          location: this.address,
          addressDetail: this.addressDetail
        },
        hub: {
          origin: this.payloads.origin_city,
          destination: this.payloads.destination_city,
          goodsCategory: this.selectedPackage?.code,
          packageSize: this.selectPackageSize?.code
        }
      }
      this.showLoading()
      this.localStorageAsync.set('order_shipping', JSON.stringify(data)).then(() => {
        setTimeout(() => {
          this.hideLoading()
          this.$router.push('/order/step/logistic')
        }, 2000)
      })
    },
    getGoodsCategoryList() {
      this.getGoodsCategories().then(() => {
        this.selectedPackageCategory = this.goodsCategories.filter(item => item.code === this.shippingInfo.hub.goodsCategory)[0]
      })
    },
    getPackageSizeList() {
      this.getPackageSizes()
    },
    searchCity(value, target) {
      this.cityKeyword = null
      this.isSearching[target] = true
      this.visibleSuggestion[target] = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.cityKeyword = value
        this.getCities({
          params: {
            page: 1,
            per_page: 1000,
            search_keyword: this.cityKeyword
          }
        }).then(() => {
          this.visibleSuggestion[target] = true
          this.isSearching[target] = false
        })
      }, 200)
    },
    selectCity(data, target) {
      if (target === 'origin') {
        this.payloads.origin_city = data
        this.originSearch = `${data.village}, ${data.area_display}`
      } else {
        this.payloads.destination_city = data
        this.destinationSearch = `${data.village}, ${data.area_display}`
      }
      this.visibleSuggestion[target] = false
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.arrow {
  margin: 0 0 0 -12px;
  -webkit-clip-path: polygon(20px 50%, 0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);

  &:first-child {
    -webkit-clip-path: polygon(0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);
  }

  &:last-child {
    -webkit-clip-path: polygon(20px 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
}

.stepper {
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    content: '';
  }
}

.place {
  &::v-deep input {
    padding: 12px 12px 12px 44px;
    outline: none;
    border-radius: 8px;
    border: 1px solid #ced5de;
    width: 100%;
  }
}

.sticky-element {
  position: sticky;
  top: 130px;
}

.sub {
  max-height: 0;
  padding: 0;
  color: black;
  background: white;
  transition: all 250ms;
}

input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

input[type='checkbox'] ~ label span {
  transition: all 250ms;
}

// input[type='checkbox']:checked ~ .sub {
//   max-height: 9999px;
//   padding: 12px 0;
// }
.open {
  max-height: 9999px;
  padding: 12px 0;
}
</style>
